module.exports = __webpack_public_path__ + "img/feedback.svg";